import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { ConfirmationModal, TextField, Typography } from 'seagull';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './StopPaymentModal.module.scss';
export default function StopPaymentModal(props) {
    const { formattedNumber, onSubmit, dismissModal } = props;
    const { control, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            reason: ''
        }
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: "Stop Payment?",
        textAlignCenter: false,
        primaryButtonLabel: "Stop",
        primaryButtonTestId: "submit-stop-payment",
        secondaryButtonLabel: "Back",
        onSecondaryButtonClick: ()=>dismissModal(),
        onPrimaryButtonClick: handleSubmit(async (param)=>{
            let { reason } = param;
            const { success } = await onSubmit(reason.trim());
            if (success) dismissModal();
        }),
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    children: [
                        "You're about to stop a payment for invoice ",
                        formattedNumber,
                        "."
                    ]
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: "Please provide a reason for stopping:"
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "reason",
                    rules: requiredValidation(true),
                    render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
                            collapseHelperText: false,
                            multiline: true,
                            minRows: 6,
                            testId: "stop-payment-reason",
                            placeholder: "[Example text] Can you remind me what this payment is for? Please call me to discuss..."
                        }, connectControllerToTextField(renderProps)))
                })
            ]
        })
    });
}
